(() => {
  let cachedRate = null;
  let ratePromise = null;

  async function fetchJson(url) {
    const response = await fetch(url, { cache: 'no-store' });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status} en ${url}`);
    }

    return response.json();
  }

  async function getCopToUsdRate() {
    if (cachedRate) return cachedRate;

    if (!ratePromise) {
      ratePromise = (async () => {
        const urls = [
          'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/cop.min.json',
          'https://latest.currency-api.pages.dev/v1/currencies/cop.min.json'
        ];

        let data = null;
        let lastError = null;

        for (const url of urls) {
          try {
            data = await fetchJson(url);
            break;
          } catch (error) {
            lastError = error;
          }
        }

        if (!data) {
          throw lastError || new Error('No se pudo consultar la tasa');
        }

        const rate = data?.cop?.usd;

        if (typeof rate !== 'number') {
          throw new Error('No llegó la tasa COP → USD');
        }

        cachedRate = rate;
        return rate;
      })().catch((error) => {
        ratePromise = null;
        throw error;
      });
    }

    return ratePromise;
  }

  function formatUsd(value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  }

  async function updateUsdPrices() {
    const nodes = document.querySelectorAll('.js-usd-price');
    if (!nodes.length) return;

    try {
      const rate = await getCopToUsdRate();

      nodes.forEach((node) => {
        const cents = Number(node.dataset.priceCents || 0);

        if (!cents) {
          node.textContent = '';
          return;
        }

        const currentCents = String(cents);
        const alreadyRendered = node.dataset.renderedCents;

        if (alreadyRendered === currentCents) return;

        const cop = cents / 100;
        const usd = cop * rate;

        node.textContent = `· ${formatUsd(usd)} USD aprox.`;
        node.dataset.renderedCents = currentCents;
      });
    } catch (error) {
      console.error('Error cargando precio USD:', error);

      document.querySelectorAll('.js-usd-price').forEach((node) => {
        node.textContent = '';
      });
    }
  }

  document.addEventListener('DOMContentLoaded', updateUsdPrices);
  window.addEventListener('pageshow', updateUsdPrices);

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!target) return;

    const changedVariant =
      target.name === 'id' ||
      target.closest('variant-radios') ||
      target.closest('variant-selects');

    if (changedVariant) {
      setTimeout(updateUsdPrices, 300);
    }
  });
})();